"use client";

import React from "react";
import { Sparkles, TestTube } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrimaryCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section data-section-id="168148" id="call-to-action" className="relative w-full bg-background text-foreground py-24 md:py-32 lg:py-40 flex flex-col items-center justify-center overflow-hidden">
      <div className="container px-4 md:px-6 max-w-5xl mx-auto text-center">
        <div ref={ref} className={`flex flex-col items-center transition-all duration-1000 ease-[cubic-bezier(0.16,1,0.3,1)] transform ${isVisible ? "translate-y-0 opacity-100" : "translate-y-16 opacity-0"}`}>
          <div className="overflow-hidden mb-6">
            <h2 className={`font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-medium tracking-tight text-foreground leading-[1.1] transition-transform duration-1000 delay-100 ease-[cubic-bezier(0.16,1,0.3,1)] ${isVisible ? "translate-y-0" : "translate-y-[100%]"}`}>
              Ready to Restore Your Natural Alignment?
            </h2>
          </div>

          <p className={`font-sans font-medium text-lg sm:text-xl md:text-2xl text-foreground/80 max-w-3xl mx-auto mb-12 transition-all duration-1000 delay-300 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            Schedule your expert consultation in Nicosia today and take the first step toward a pain-free, active lifestyle.
          </p>

          <div className={`flex items-center justify-center gap-6 sm:gap-8 transition-all duration-1000 delay-500 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <TestTube className="w-8 h-8 text-accent shrink-0" strokeWidth={1} aria-hidden="true" />
            
            <Button asChild size="lg" className="rounded-full bg-primary text-primary-foreground hover:bg-accent hover:text-accent-foreground text-lg sm:text-xl px-10 py-8 h-auto transition-colors duration-500 ease-in-out shadow-xl hover:shadow-2xl">
              <Link to="/ContactPage">Book Your Appointment</Link>
            </Button>

            <Sparkles className="w-8 h-8 text-accent shrink-0" strokeWidth={1} aria-hidden="true" />
          </div>
        </div>
      </div>
    </section>;
}